export enum UserPermission {
  DisableCompanyUsers = 'disableCompanyUsers',
  ImpersonateCustomer = 'impersonateCustomer',
  ManageAgency = 'manageAgency',
  ManageAgencies = 'manageAgencies',
  ManageAgencyCustomerReservations = 'manageAgencyCustomerReservations',
  ManageAgencyUsers = 'manageAgencyUsers',
  ManageAgentBulletinBoard = 'manageAgentBulletinBoard',
  ManageCompanies = 'manageCompanies',
  ManageCompanyReservations = 'manageCompanyReservations',
  ManageCorporateCompany = 'manageCorporateCompany',
  ManageCorporateCompanies = 'manageCorporateCompanies',
  ManageCorporateUsers = 'manageCorporateUsers',
  ManageCorporateCustomerReservations = 'manageCorporateCustomerReservations',
  ManageCustomerUsers = 'manageCustomerUsers',
  ManageInventoryClasses = 'manageInventoryClasses',
  ManageNCUsers = 'manageNCUsers',
  ManageOrderFilesAccess = 'manageOrderFilesAccess',
  ManageOwnReservations = 'manageOwnReservations',
  ManagePortalSettings = 'managePortalSettings',
  ManageQuotes = 'manageQuotes',
  ManageReelReturns = 'manageReelReturns',
  ManageRolesAndPermissions = 'manageRolesAndPermissions',
  ManageTwoFactorAuthSettings = 'manageTwoFactorAuthSettings',
  RequestQuotes = 'requestQuotes',
  ViewAgencyQuotes = 'viewAgencyQuotes',
  ViewAllReservations = 'viewAllReservations',
  ViewCommissionsReports = 'viewCommissionsReports',
  ViewCompanyQuotes = 'viewCompanyQuotes',
  ViewCompanyUsers = 'viewCompanyUsers',
  ViewCorporateQuotes = 'viewCorporateQuotes',
  ViewReservationConversionRatesReports = 'viewReservationConversionRatesReports',
  ViewInventory = 'viewInventory',
  ViewInventorySearchReports = 'viewInventorySearchReports',
  ViewLogs = 'viewLogs',
  ViewOrders = 'viewOrders',
  ViewOrdersConfirmation = 'viewOrdersConfirmation',
  ViewOrdersInvoice = 'viewOrdersInvoice',
  ViewOrdersShipping = 'viewOrdersShipping',
  ViewQuoteReports = 'viewQuoteReports',
  ViewReelReturns = 'viewReelReturns',
  ViewReservationReports = 'viewReservationReports',
  ViewSalesReports = 'viewSalesReports',
}
